export default "__VITE_ASSET__CUp9orPV__"